import ClipboardJS from 'clipboard'
import Swiper from 'swiper'
import ScrollHint from 'scroll-hint'

/* eslint-disable no-unused-vars */
window.document.addEventListener('DOMContentLoaded', function () {
  var clipboard = new ClipboardJS('.social-share__button')
  clipboard.on('success', function () {
    var elm = document.querySelector('.social-share__toast')
    elm.classList.toggle('social-share__toast_active')
    setTimeout(function () {
      elm.classList.toggle('social-share__toast_active')
    }, 2000)
  })

  var galleryThumbs = new Swiper('.photo-thumb-swiper', {
    spaceBetween: 12,
    centeredSlides: true,
    slidesPerView: 4,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    slideActiveClass: 'photo-container__thumb-slide_active',
  })
  var galleryTop = new Swiper('.photo-swiper', {
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
  galleryThumbs = [].concat(galleryThumbs)
  galleryTop = [].concat(galleryTop)

  if (galleryThumbs.length > 0) {
    galleryThumbs.forEach((e, i) => {
      if (!e.controller) return
      e.controller.control = galleryTop[i]
      galleryTop[i].controller.control = e
    })
  }

  var amazonGalleryThumbs = new Swiper('.amazon-thumb-swiper', {
    spaceBetween: 12,
    centeredSlides: true,
    slidesPerView: 4.5,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    slideActiveClass: 'photo-container__thumb-slide_active',
  })

  var amazonGalleryTop = new Swiper('.amazon-swiper', {
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  amazonGalleryThumbs = [].concat(amazonGalleryThumbs)
  amazonGalleryTop = [].concat(amazonGalleryTop)

  if (amazonGalleryThumbs.length > 0) {
    amazonGalleryThumbs.forEach((e, i) => {
      if (!e.controller) return
      e.controller.control = amazonGalleryTop[i]
      amazonGalleryTop[i].controller.control = e
    })
  }

  var reviewSwiper = new Swiper('.review-swiper', {
    spaceBetween: 16,
    setWrapperSize: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      bulletActiveClass: 'swiper-pagination-bullet-active swiper-pagination-bullet-active_theme',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  new ScrollHint('.js-scrollable', {
    i18n: {
      scrollable: 'スクロールできます',
    },
  })

  // Google Analytics: aタグのクリック数計測
  const allLinks = Array.from(document.getElementsByTagName('a'))
  allLinks.forEach((node) => {
    const unitWrapper = node.closest('.unit-wrapper')
    if (unitWrapper) {
      node.addEventListener('click', () => {
        // eslint-disable-next-line no-undef
        gtag('event', node.getAttribute('href'), {
          event_category: unitWrapper.dataset.unitType,
          event_label: unitWrapper.dataset.unitId,
        })
        // eslint-disable-next-line no-undef
        gtag('event', 'unitClickEvent', {
          url: node.getAttribute('href'),
          unitType: unitWrapper.dataset.unitType,
          unitId: unitWrapper.dataset.unitId,
        })
      })
    }
  })
  const toc = document.getElementById('top_toc')
  if (toc) {
    const moreButton = toc.getElementsByClassName('toc__more')[0]
    const closeButton = toc.getElementsByClassName('toc__close')[0]
    if (toc.clientHeight && toc.clientHeight > 530) {
      toc.classList.add('toc_fold')
      moreButton.addEventListener('click', function () {
        toc.classList.remove('toc_fold')
        moreButton.classList.add('toc__more_hidden')
        closeButton.classList.remove('toc__close_hidden')
      })
      closeButton.addEventListener('click', function () {
        toc.classList.add('toc_fold')
        moreButton.classList.remove('toc__more_hidden')
        closeButton.classList.add('toc__close_hidden')
      })
    } else {
      moreButton.classList.add('toc__more_hidden')
    }
  }
})

//追随見出しがある場合、記事内ジャンプした時のずれを修正
window.addEventListener('DOMContentLoaded', function () {
  if (document.getElementsByClassName('shorten-headline').length > 0) {
    let htmlElement = document.querySelector('html')
    htmlElement.style.scrollPaddingTop = '45px'
  }
})

/* eslint-enable no-unused-vars */
